import { Link } from "react-router-dom";
import { ChevronRight, Tag } from "lucide-react";
import { PG_CHANNELS, PRODUCTS } from "./catalog";

export default function TestPaymentPage() {
  const pg = PG_CHANNELS.kakao;

  return (
    <div className="min-h-screen bg-black text-white flex flex-col items-center justify-center px-4 py-12">
      {/* Background blobs */}
      <div className="fixed inset-0 opacity-20 pointer-events-none">
        <div className="absolute top-10 left-10 w-64 h-64 bg-yellow-400 rounded-full mix-blend-multiply filter blur-2xl animate-blob"></div>
        <div className="absolute bottom-10 right-10 w-64 h-64 bg-blue-400 rounded-full mix-blend-multiply filter blur-2xl animate-blob animation-delay-2000"></div>
      </div>

      <div className="relative z-10 w-full max-w-4xl">
        {/* Header */}
        <div className="flex items-center gap-3 mb-10">
          <div className="w-10 h-10 bg-gradient-to-br from-blue-500 to-purple-600 rounded-xl flex items-center justify-center">
            <Tag className="w-5 h-5" />
          </div>
          <span className="text-xl font-bold">TMTT.Link</span>
          <span className={`ml-2 text-xs border rounded-full px-2 py-0.5 ${pg.badgeClass}`}>
            {pg.label} 테스트
          </span>
        </div>

        <h1 className="text-3xl font-bold mb-2">결제 테스트</h1>
        <p className="text-gray-400 mb-8 text-sm">상품을 선택하면 상세 페이지로 이동한 뒤 결제를 진행할 수 있습니다.</p>

        {/* Product Cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          {Object.entries(PRODUCTS).map(([key, product]) => (
            <Link
              key={key}
              to={`/test/${key}`}
              className="bg-gray-900 border border-gray-800 rounded-2xl overflow-hidden transition-colors hover:border-gray-600 block"
            >
              {/* Product Image */}
              <div className="w-full bg-gray-800" style={{ aspectRatio: "891 / 1260" }}>
                <img
                  src={product.image}
                  alt={product.name}
                  className="w-full h-full object-cover"
                />
              </div>
              {/* Product Info + Button */}
              <div className="p-5">
                <p className="font-semibold text-base">{product.name}</p>
                <p className="text-sm text-gray-400 mt-0.5">{product.description}</p>
                <div className="flex items-center justify-between mt-4 gap-4">
                  <p className="font-bold text-lg text-white">
                    {product.price.toLocaleString()}원
                  </p>
                  <span className={`flex items-center gap-2 font-bold rounded-xl px-4 py-2.5 text-sm whitespace-nowrap ${pg.buttonClass}`}>
                    상세보기
                    <ChevronRight className="w-4 h-4" />
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>

        {/* Service Info */}
        <div className="mt-6 bg-gray-900/60 border border-gray-800 rounded-xl p-4 text-sm text-gray-300">
          <span className="text-gray-500">서비스 제공 기간:</span> APP 상품은 구매 후 바로 같이 사용 가능합니다!
        </div>
      </div>

      <style jsx global>{`
        @keyframes blob {
          0% { transform: translate(0px, 0px) scale(1); }
          33% { transform: translate(30px, -50px) scale(1.1); }
          66% { transform: translate(-20px, 20px) scale(0.9); }
          100% { transform: translate(0px, 0px) scale(1); }
        }
        .animate-blob { animation: blob 7s infinite; }
        .animation-delay-2000 { animation-delay: 2s; }
      `}</style>
    </div>
  );
}
